import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import { performGlobalLogout } from './authSlice';
const normalizePayload = (payload) => {
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    return payload.data ?? payload.result ?? payload.payload ?? payload;
  }
  return payload;
};

///card 32
export const card32roundresult = createAsyncThunk(
  'winner/card32roundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/card-32/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///andar-bahar
export const andarbaharroundresult = createAsyncThunk(
  'winner/andarbaharroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/andar-bahar/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///aviator
export const aviatorroundresult = createAsyncThunk(
  'winner/aviatorroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/aviator/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///baccarat
export const baccaratroundresult = createAsyncThunk(
  'winner/baccaratroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/baccarat/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///bollywood
export const bollywoodroundresult = createAsyncThunk(
  'winner/bollywoodroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/bollywood/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///dragon-tiger
export const dragontigerroundresult = createAsyncThunk(
  'winner/dragontigerroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/dragon-tiger/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///dtl
export const dtlroundresult = createAsyncThunk(
  'winner/dtlroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/dtl/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///lucky7
export const lucky7roundresult = createAsyncThunk(
  'winner/lucky7roundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/lucky7/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///oneday-dt
export const onedaydtroundresult = createAsyncThunk(
  'winner/onedaydtroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/oneday-dt/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///roulette
export const rouletteroundresult = createAsyncThunk(
  'winner/rouletteroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/roulette/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///teen-patti
export const teenpattiroundresult = createAsyncThunk(
  'winner/teenpattiroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/teen-patti/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///two-card
export const twocardroundresult = createAsyncThunk(
  'winner/twocardroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/two-card/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);

///aaa
export const aaaroundresult = createAsyncThunk(
  'winner/aaaroundresult',
  async ({ roundId, gameId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/aaa/round-result/${roundId}/${gameId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch message');
    }
  }
);
const winnerSlice = createSlice({
  name: 'winner',
  initialState: {
    data: [],
    text: '',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Card 32
      .addCase(card32roundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(card32roundresult.fulfilled, (state, action) => {
        state.loading = false;
       state.data = normalizePayload(action.payload);
      })
      .addCase(card32roundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Andar Bahar
      .addCase(andarbaharroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(andarbaharroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(andarbaharroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Aviator
      .addCase(aviatorroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(aviatorroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(aviatorroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Baccarat
      .addCase(baccaratroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(baccaratroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(baccaratroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Bollywood
      .addCase(bollywoodroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bollywoodroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(bollywoodroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Dragon Tiger
      .addCase(dragontigerroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dragontigerroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(dragontigerroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Dragon Tiger Lion
      .addCase(dtlroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dtlroundresult.fulfilled, (state, action) => {
        state.loading = false;
      state.data = normalizePayload(action.payload);
      })
      .addCase(dtlroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Lucky7
      .addCase(lucky7roundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(lucky7roundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(lucky7roundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // One Day Dragon Tiger
      .addCase(onedaydtroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(onedaydtroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(onedaydtroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Roulette
      .addCase(rouletteroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rouletteroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(rouletteroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Teen Patti
      .addCase(teenpattiroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(teenpattiroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(teenpattiroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Two Card
      .addCase(twocardroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(twocardroundresult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = normalizePayload(action.payload);
      })
      .addCase(twocardroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // aaa
      .addCase(aaaroundresult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(aaaroundresult.fulfilled, (state, action) => {
        state.loading = false;
    state.data = normalizePayload(action.payload);
      })
      .addCase(aaaroundresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GLOBAL LOGOUT
      .addCase(performGlobalLogout.fulfilled, (state) => {
        state.data = [];
        state.text = '';
        state.loading = false;
        state.error = null;
      });
  }
});

export default winnerSlice.reducer;